import { Input } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';

interface FormFieldDateTimeProps {
    field: FormFieldDto;
}

export function FormFieldDateTime({ field }: FormFieldDateTimeProps) {
    const title = field.validation?.find((v) => v.type === 'pattern')?.message;
    const minDate = field.validation?.find((v) => v.type === 'minDate')?.value;
    const maxDate = field.validation?.find((v) => v.type === 'maxDate')?.value;
    const min = field.validation?.find((v) => v.type === 'min')?.value;
    const max = field.validation?.find((v) => v.type === 'max')?.value;

    return (
        <Input
            name={field.name}
            required={field.required}
            placeholder={field.options?.placeholder}
            defaultValue={field.options?.defaultValue}
            type="datetime-local"
            className="form-input"
            title={title}
            min={min || minDate}
            max={max || maxDate}
        />
    );
}
